module.exports = __webpack_public_path__ + "img/Q@2x.25c2620f.jpg";